/*
 * This file is part of ng2-json-editor.
 * Copyright (C) 2017 CERN.
 *
 * ng2-json-editor is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License as
 * published by the Free Software Foundation; either version 2 of the
 * License, or (at your option) any later version.
 *
 * ng2-json-editor is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with ng2-json-editor; if not, write to the Free Software Foundation, Inc.,
 * 59 Temple Place, Suite 330, Boston, MA 02111-1307, USA.
 * In applying this license, CERN does not
 * waive the privileges and immunities granted to it by virtue of its status
 * as an Intergovernmental Organization or submit itself to any jurisdiction.
 */

import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { AbstractSubscriberComponent } from '../../abstract-subscriber';
import { DomUtilService, PathUtilService, ProblemsService } from '../../shared/services';
import { SchemaValidationProblems, ProblemCollectionType } from '../../shared/interfaces';


export class ProblemsConsoleTabComponent extends AbstractSubscriberComponent implements OnInit {

   problemType: ProblemCollectionType;

  internalProblemMap: SchemaValidationProblems;
  externalProblemMap: SchemaValidationProblems;
  problemCount = 0;
  iconClassName: string;

  constructor(public domUtilService: DomUtilService,
    public pathUtilService: PathUtilService,
    public problemsService: ProblemsService,
    public changeDetectorRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.problemsService.externalCategorizedProblems$
      .map(categorizedProblemMap => categorizedProblemMap[this.problemType])
      .takeUntil(this.isDestroyed)
      .subscribe(problemMap => {
        this.externalProblemMap = problemMap;
        this.changeDetectorRef.markForCheck();
      });
    this.problemsService.internalCategorizedProblems$
      .map(categorizedProblemMap => categorizedProblemMap[this.problemType])
      .takeUntil(this.isDestroyed)
      .subscribe(problemMap => {
        this.internalProblemMap = problemMap;
        this.changeDetectorRef.markForCheck();
      });

    // TODO: create WarningsConsoleTabComponent with same template to avoid `if`

    const problemCount$ = this.problemType === 'errors' ? this.problemsService.errorCount$ : this.problemsService.warningCount$;
    problemCount$
      .takeUntil(this.isDestroyed)
      .subscribe(problemCount => {
        this.problemCount = problemCount;
      });

    this.iconClassName = this.problemType === 'errors' ? 'fa fa-times' : 'fa fa-exclamation-triangle';
  }

  focusAndSelectPath(path: string) {
    this.domUtilService.focusAndSelectFirstEditableChildById(path, true);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'problems-console-tab',
  styles: [".list-group-item:hover { background-color: #faebcc; } .list-group-item:hover > .title { text-decoration: underline; } .list-group-item:hover.nested { background-color: #e2dcd1; } .list-group-item .title { cursor: pointer; color: #0074D9; } ",
".fa-exclamation-triangle { color: #f1c40f; } .fa-times { color: #D14024; } "],
  template: "<ng-template tabHeading> <i [ngClass]=\"iconClassName\"></i> {{problemType | titlecase}} <span class=\"badge\">{{problemCount}}</span> </ng-template> <ul class=\"list-group\"> <ng-container *ngFor=\"let key of internalProblemMap | keys\"> <li *ngFor=\"let problem of internalProblemMap[key]\" class=\"list-group-item\" (click)=\"focusAndSelectPath(key)\"> <i [ngClass]=\"iconClassName\"></i> {{ problem.message }} </li> </ng-container> <ng-container *ngFor=\"let key of externalProblemMap | keys\"> <li *ngFor=\"let problem of externalProblemMap[key]\" class=\"list-group-item\" (click)=\"focusAndSelectPath(key)\"> <i [ngClass]=\"iconClassName\"></i> {{ problem.message }} </li> </ng-container> </ul>",
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DomUtilService, },
{type: PathUtilService, },
{type: ProblemsService, },
{type: ChangeDetectorRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'problemType': [{ type: Input },],
};
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
